import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";
import type { Brand, BrandOverride } from "../types/brand";

/** Бренд тенанта — без токена (страница входа, портал). */
export function useTenantBrand() {
  return useQuery({ queryKey: ["brand", "tenant"], queryFn: () => api.get<Brand>("/brand"), staleTime: 60_000 });
}

/** Бренд для текущего сотрудника: объект его отдела поверх тенанта. */
export function useMyBrand(enabled: boolean) {
  return useQuery({ queryKey: ["brand", "me"], queryFn: () => api.get<Brand>("/brand/me"), enabled, staleTime: 60_000 });
}

export function useObjectBrand(objectId: string | null | undefined) {
  return useQuery({
    queryKey: ["brand", "object", objectId],
    queryFn: () => api.get<Brand>(`/brand/objects/${objectId}`),
    enabled: Boolean(objectId),
    staleTime: 60_000,
  });
}

export function useObjectBrandOverride(objectId: string | null) {
  return useQuery({
    queryKey: ["brand", "override", objectId],
    queryFn: () => api.get<BrandOverride>(`/brand/objects/${objectId}/override`),
    enabled: Boolean(objectId),
  });
}

export function useSaveTenantBrand() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Brand) => api.put<Brand>("/brand", body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["brand"] }),
  });
}

export function useSaveObjectBrandOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ objectId, body }: { objectId: string; body: BrandOverride }) =>
      api.put<BrandOverride>(`/brand/objects/${objectId}/override`, body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["brand"] }),
  });
}
